export const environment = {
    production: true,
    api_url: "https://outbox.ashcorp.co/",
    cdn_url: "https://outbox-assets.ashcorp.co/",
    websocket: {
        url: "wss://service.ashcorp.co/socket.io",
        realm: "outbox-ashcorp-co"
    }
};
